import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "and",
  "use": "and-usage",
  "viewBox": "0 0 13 14",
  "content": "<symbol viewBox=\"0 0 13 14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"and\"><path d=\"M12.114 12.816H8.82l-1.188-1.26c-.936.9-2.16 1.476-3.546 1.476-2.07 0-4.086-1.314-4.086-3.78 0-1.728 1.044-2.79 2.16-3.528-.612-.774-1.08-1.566-1.08-2.61C1.08 1.17 2.664 0 4.608 0c2.088 0 3.384 1.35 3.384 3.024 0 1.332-.828 2.376-2.196 3.132l1.602 1.656c.27-.63.486-1.242.72-1.998h2.538c-.378 1.332-.954 2.682-1.548 3.816l3.006 3.186zM6.048 9.882L3.69 7.38c-.63.432-1.188 1.044-1.188 1.89 0 1.08.882 1.53 1.656 1.53a2.45 2.45 0 0 0 1.89-.918zM4.302 4.554c.792-.45 1.206-.972 1.206-1.476 0-.486-.36-.864-.936-.864-.558 0-.99.36-.99.9 0 .486.342.954.72 1.44z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/svg/and.svg
// module id = 1540
// module chunks = 0